import { PARKING_SEARCH_TYPE } from "~/utilities/constants"
import PlateState from "./PlateState"
import TicketNumber from "./TicketNumber"
import PlateNumber from "./PlateNumber"

export const SEARCH_OPTIONS = {
  plateNumber: "plateNumber",
  plateState: "plateState",
  ticketNumber: "ticketNumber"
}

export const USER_INFO_SEARCH_OPTIONS = {
  fullName: "fullName",
  email: "email",
  phoneNumber: "phoneNumber"
}

export const SEARCH_OPTIONS_VALIDATION_KEYS = {
  [SEARCH_OPTIONS.plateNumber]: ["plateNumber"],
  [SEARCH_OPTIONS.nameDOBGender]: [
    "firstName",
    "middleName",
    "lastName",
    "DOBString",
    "gender"
  ],
  [SEARCH_OPTIONS.ticketNumber]: ["trafficTicketNumber"]
}

export const SEARCH_OPTIONS_COMPONENTS = {
  [SEARCH_OPTIONS.plateNumber]: PlateNumber,
  [SEARCH_OPTIONS.plateState]: PlateState,
  [SEARCH_OPTIONS.ticketNumber]: TicketNumber
}

export const SEARCH_COLUMNS_BY_TYPE = {
  [PARKING_SEARCH_TYPE.plate]: [
    SEARCH_OPTIONS.plateNumber,
    SEARCH_OPTIONS.plateState
  ],
  [PARKING_SEARCH_TYPE.ticketId]: [SEARCH_OPTIONS.ticketNumber]
}
